// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadCrumb_breadcrumb__45S0t","head":"breadCrumb_head__NNjvI","back":"breadCrumb_back__3Tp7n"};